module.exports = __webpack_public_path__ + "img/kefuCode.a6bffb6e.png";